<template>
  <div :class="[(page.id == 'participants') ? 'participants-list' : '', 'contact-list']" v-if="page">
  
    <h2 v-if="page" :class="[(page.id == 'participants') ? 'mt-4' : '', 'container text-center']">{{page.title}}</h2>
    
    <div v-if="!ContactItems" class="container-fluid alert alert-danger text-center box-fixed">
      <strong>No user found!</strong>
    </div>

    <ContactListItem v-for="contactItem in ContactItems"
      :key="contactItem.id"
      :contactItem="contactItem" 
      :eventItem="eventItem" 
      :page="page.id" 
      :pathTo = "pathTo +'/contact-'+ contactItem.id"
      :menuClass="'btn-list'" />
  </div>
</template>

<script>
import ContactListItem from '../contacts/ContactListItem';

export default {
  name: 'ContactList',
  props: ['type', 'page', 'eventItem', 'ContactItems', 'pathTo'],
  components: {
    ContactListItem
  }
}
</script>

<style>
</style>

<style scoped>
</style>
